import { render } from "./AddDestinationModal.vue?vue&type=template&id=81681772"
import script from "./AddDestinationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDestinationModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/AddDestinationModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81681772"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81681772', __exports__)) {
    api.reload('81681772', __exports__)
  }
  
  module.hot.accept("./AddDestinationModal.vue?vue&type=template&id=81681772", () => {
    api.rerender('81681772', render)
  })

}


export default __exports__